<template>
    <div>
        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>铺单机器人</span>
                <el-button v-if="dataList.length==0" style="float: right; padding: 3px 0" type="text" @click="openAddRobotOderDialog">新增</el-button>
            </div>
            <el-table class="robot-order-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column fixed prop="pair" label="交易对" width="150"></el-table-column>
                <el-table-column prop="userId" label="用户id" show-overflow-tooltip></el-table-column>
                <el-table-column label="买单铺单配置">
                    <el-table-column prop="bidCreateConfig.minPrice" label="铺单价格最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidCreateConfig.maxPrice" label="铺单价格最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidCreateConfig.priceGapLower" label="价格区间最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidCreateConfig.priceGapUpper" label="价格区间最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidCreateConfig.eachOrderQtyLower" label="数量区间最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidCreateConfig.eachOrderQtyUpper" label="数量区间最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column label="执行状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.bidCreateConfig.status | statusFormat}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="卖单铺单配置">
                    <el-table-column prop="askCreateConfig.minPrice" label="铺单价格最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="askCreateConfig.maxPrice" label="铺单价格最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="askCreateConfig.priceGapLower" label="价格区间最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="askCreateConfig.priceGapUpper" label="价格区间最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="askCreateConfig.eachOrderQtyLower" label="数量区间最小值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="askCreateConfig.eachOrderQtyUpper" label="数量区间最大值"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column label="执行状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.askCreateConfig.status | statusFormat}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="撤买单配置">
                    <el-table-column prop="bidCancelConfig.price" label="大于此价格" show-overflow-tooltip></el-table-column>
                    <el-table-column label="执行状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.bidCancelConfig.status | statusFormat}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="撤卖单配置">
                    <el-table-column prop="askCancelConfig.price" label="小于此价格" show-overflow-tooltip></el-table-column>
                    <el-table-column label="执行状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.askCancelConfig.status | statusFormat}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="350">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="openBidCreateConfigDialog(scope.row)"
                                   style="margin: 5px">买单铺单
                        </el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="openAskCreateConfigDialog(scope.row)"
                                   style="margin: 5px">卖单铺单
                        </el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="openBidCancelConfigDialog(scope.row)"
                                   style="margin: 5px">撤买单
                        </el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="openAskCancelConfigDialog(scope.row)"
                                   style="margin: 5px">撤卖单
                        </el-button>
                        <el-button type="primary" icon="el-icon-edit" @click="executeConfig(scope.row)"
                                   style="margin: 5px">执行
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!--创建主记录弹框-->
        <el-dialog title="新增" :visible.sync="addDialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="addData.pair" :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="addData.userId"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addRobotOder()">确 定</el-button>
            </span>
        </el-dialog>

        <!--修改撤买单配置弹框-->
        <el-dialog :title="cancelConfigTitle" :visible.sync="cancelConfigDialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="addData.pair" :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="addData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span v-if="currOpration=='BIDCANCELCONFIG'" style="padding-right: 20px">大于此价格</span>
                    <span v-if="currOpration=='ASKCANCELCONFIG'" style="padding-right: 20px">小于此价格</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="addData.price"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addRobotOder()">确 定</el-button>
            </span>
        </el-dialog>

        <!--修改买单铺单配置弹框-->
        <el-dialog :title="createConfigTitle" :visible.sync="createConfigDialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="createData.pair" :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">铺单价格最小值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.minPrice"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">铺单价格最大值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.maxPrice"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">价格区间最小值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.priceGapLower"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">价格区间最大值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.priceGapUpper"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">数量区间最小值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.eachOrderQtyLower"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">数量区间最大值</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="createData.eachOrderQtyUpper"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="updateCreateConfig()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'RobotSpreadOrder',
        props: {dataList: Array, pair: String},
        data() {
            return {
                loading: false,
                addDialogVisible: false,
                cancelConfigDialogVisible: false,
                cancelConfigTitle: "",
                createConfigDialogVisible: false,
                createConfigTitle: "",
                currOpration: "", //ADD-增加主记录，BIDCREATECONFIG-买单铺单修改，ASKCREATECONFIG-买单铺单修改，BIDCANCELCONFIG-撤买单修改，ASKCANCELCONFIG-撤卖单修改
                addData: { //撤单
                    userId: "",
                    pair: "",
                    price: 0,
                    isBid: false
                },
                createData: { //铺单
                    userId: "",
                    pair: "",
                    minPrice: 0,
                    maxPrice: 0,
                    priceGapLower: 0,
                    priceGapUpper: 0,
                    eachOrderQtyLower: 0,
                    eachOrderQtyUpper: 0,
                    isBid: false
                }
            };
        },
        filters: {
            statusFormat(status) {
                let desc = "";
                if (status == 'NOT_STARTED') {
                    desc = "未开始";
                } else if (status == 'STARTING') {
                    desc = "正在进行";
                } else if (status == 'FINISHED') {
                    desc = "已完成";
                }
                return desc;
            }
        },
        methods: {
            findSpreadList() {
                this.$emit('refreshData');
            },
            openAddRobotOderDialog() {
                this.createData.pair = this.pair;
                this.addData.pair = this.pair;
                this.currOpration = "ADD";
                this.addDialogVisible = true;
            },
            openBidCreateConfigDialog(row) {
                this.createData = { //铺单
                    userId: row.userId,
                    pair: row.pair,
                    minPrice: row.bidCreateConfig.minPrice,
                    maxPrice: row.bidCreateConfig.maxPrice,
                    priceGapLower: row.bidCreateConfig.priceGapLower,
                    priceGapUpper: row.bidCreateConfig.priceGapUpper,
                    eachOrderQtyLower: row.bidCreateConfig.eachOrderQtyLower,
                    eachOrderQtyUpper: row.bidCreateConfig.eachOrderQtyUpper,
                    isBid: true
                }
                this.createConfigTitle = "修改买单铺单配置";
                this.currOpration = "BIDCREATECONFIG";
                this.createConfigDialogVisible = true;
            },
            openAskCreateConfigDialog(row) {
                this.createData = { //铺单
                    userId: row.userId,
                    pair: row.pair,
                    minPrice: row.askCreateConfig.minPrice,
                    maxPrice: row.askCreateConfig.maxPrice,
                    priceGapLower: row.askCreateConfig.priceGapLower,
                    priceGapUpper: row.askCreateConfig.priceGapUpper,
                    eachOrderQtyLower: row.askCreateConfig.eachOrderQtyLower,
                    eachOrderQtyUpper: row.askCreateConfig.eachOrderQtyUpper,
                    isBid: false
                }
                this.createConfigTitle = "修改卖单铺单配置";
                this.currOpration = "ASKCREATECONFIG";
                this.createConfigDialogVisible = true;
            },
            openBidCancelConfigDialog(row) {
                this.addData = {
                    userId: row.userId,
                    pair: row.pair,
                    price: row.bidCancelConfig.price,
                    isBid: true
                }
                this.cancelConfigTitle = "修改撤买单配置";
                this.currOpration = "BIDCANCELCONFIG";
                this.cancelConfigDialogVisible = true;
            },
            openAskCancelConfigDialog(row) {
                this.addData = {
                    userId: row.userId,
                    pair: row.pair,
                    price: row.askCancelConfig.price,
                    isBid: false
                }
                this.cancelConfigTitle = "修改撤卖单配置";
                this.currOpration = "ASKCANCELCONFIG";
                this.cancelConfigDialogVisible = true;
            },
            executeConfig(row) {
                this.$confirm('确认执行吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.executeSpreadOrCancelOrder({"pair": row.pair}).then(response => {
                        if (response.code == 0) {
                            this.$message.success('执行成功！');
                            this.findSpreadList();
                        } else {
                            this.$message.success('执行失败');
                        }
                    });
                }).catch(() => {
                });
            },
            cancleLoading() {
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            },
            updateCreateConfig() {
                if (this.createData.pair == "") {
                    this.$message.success('请输入交易对');
                    return;
                }
                if (this.createData.userId == "") {
                    this.$message.success('请输入用户id');
                    return;
                }
                if (this.createData.minPrice == "") {
                    this.$message.success('请输入铺单价格最小值');
                    return;
                }
                if (this.createData.maxPrice == "") {
                    this.$message.success('请输入铺单价格最大值');
                    return;
                }
                if (this.createData.priceGapLower == "") {
                    this.$message.success('请输入价格区间最小值');
                    return;
                }
                if (this.createData.priceGapUpper == "") {
                    this.$message.success('请输入价格区间最大值');
                    return;
                }
                if (this.createData.eachOrderQtyLower == "") {
                    this.$message.success('请输入数量区间最小值');
                    return;
                }
                if (this.createData.eachOrderQtyUpper == "") {
                    this.$message.success('请输入数量区间最大值');
                    return;
                }
                this.loading = true;
                api.updateTradersCreateConf(this.createData).then(response => {
                    if (response.code == 0) {
                        this.createConfigDialogVisible = false;
                        this.$message.success('修改成功');
                        this.findSpreadList();
                    } else {
                        this.$message.success('修改失败');
                    }
                });
                this.cancleLoading();
            },
            addRobotOder(type) {
                if (this.addData.pair == "") {
                    this.$message.success('请输入交易对');
                    return;
                }
                if (this.addData.userId == "") {
                    this.$message.success('请输入用户id');
                    return;
                }
                if ((this.currOpration == "ASKCANCELCONFIG" || this.currOpration == "BIDCANCELCONFIG") && this.addData.price == "") {
                    this.$message.success('请输入价格');
                    return;
                }
                let msg = ""
                if (this.currOpration == "ADD") {
                    msg = '增加';
                } else {
                    msg = '修改';
                }
                this.loading = true;
                api.updateTradersCancelConf(this.addData).then(response => {
                    if (response.code == 0) {
                        this.addDialogVisible = false;
                        this.cancelConfigDialogVisible = false;
                        this.$message.success(msg + '成功');
                        this.findSpreadList();
                    } else {
                        this.$message.success(msg + '失败');
                    }
                });
                this.cancleLoading();
            },
            clearData() {
                this.loading = false;
                this.cancelConfigTitle = "";
                this.createConfigTitle = "";
                this.currOpration = "";
                this.addData = { //撤单
                    userId: "",
                    pair: this.pair,
                    price: 0,
                    isBid: false
                }
                this.createData = { //铺单
                    userId: "",
                    pair: this.pair,
                    minPrice: 0,
                    maxPrice: 0,
                    priceGapLower: 0,
                    priceGapUpper: 0,
                    eachOrderQtyLower: 0,
                    eachOrderQtyUpper: 0,
                    isBid: false
                }
            }
        },
        created() {
            this.createData.pair = this.pair;
            this.addData.pair = this.pair;
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .robot-order-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .robot-order-table {
            margin-top: 30px;
        }
    }
</style>
